import { Link } from 'react-router-dom';
import { categories } from '@/mocks/news';

export default function CategoryGrid() {
  return (
    <section className="relative py-20 md:py-28 bg-background-100">
      <div className="w-full px-6 md:px-10">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full border border-primary-400/30 bg-primary-500/5 mb-4">
            <i className="ri-compass-3-line text-primary-400 text-xs"></i>
            <span className="text-primary-400 text-xs font-medium">分类导航</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            吃瓜分类 · 精准锁定
          </h2>
          <p className="mt-3 text-foreground-400 text-sm max-w-lg mx-auto">
            四大核心板块，覆盖娱乐圈所有热门话题，让你不错过任何一个大瓜
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 max-w-6xl mx-auto">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative bg-background-50 border border-foreground-200/15 rounded-xl p-7 transition-all duration-300 hover:bg-primary-500 hover:border-primary-500 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-foreground-950/5 group-hover:bg-foreground-950/20 transition-colors duration-300 mb-5">
                <i className={`${cat.icon} text-2xl text-primary-400 group-hover:text-foreground-950 transition-colors duration-300`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-800 group-hover:text-foreground-950 transition-colors duration-300 mb-2">
                {cat.name}
              </h3>
              <p className="text-foreground-400 text-sm leading-relaxed group-hover:text-foreground-800 transition-colors duration-300">
                {cat.description}
              </p>
              <div className="mt-5 flex items-center gap-1.5 text-primary-400 text-sm font-medium group-hover:text-foreground-950 transition-colors duration-300">
                浏览更多 <i className="ri-arrow-right-line text-xs group-hover:translate-x-0.5 transition-transform duration-300"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}